export const DEFAULT_LOCALE = 'ru-RU';

export const SUPPORT_LOCALES = [
  {
    name: 'Russian',
    title: 'Ru',
    key: 'ru',
    code: 'ru-RU',
    urlPrefix: null,
    translationKey: 'ru'
  },
  {
    name: 'Ukranian',
    title: 'UA',
    key: 'uk',
    code: 'ua-UA',
    urlPrefix: 'ua',
    translationKey: 'ua'
  }
];
